<h3 mat-dialog-title>Send Paper Mail</h3>
<img (click)="close()" class="mat-close" src="/assets/images/payhoa/other/icon_close.svg">

<mat-dialog-content>
    <div class="row">
        <div *ngFor="let o of options; let i = index;" class="col">
            <div [class.active]="selectedOption && selectedOption.title == o.title" [class.mb-0]="i > 1"
                 class="card"
            >
                <div (click)="choose(o)"
                     class="card-body add-hover">
                    <img [src]="o.iconImage" alt="{{o.title}}"/>
                    <h3>{{o.title}}</h3>
                    <p>{{o.description}}</p>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button class="btn btn-outline-secondary" mat-dialog-close>
        Cancel
    </button>
</mat-dialog-actions>
